import { ApolloClient, InMemoryCache, from } from '@apollo/client';
import { isBrowser } from '~/constants';
import authLink from './links/auth';
import headersLink from './links/headers';
import splitLink from './links/split';
import errorLink from './links/error';
import cacheConfig from './cache/config';

// Initialize Apollo client
const getApolloClient = (request?: Request) =>
    new ApolloClient({
        ssrMode: !isBrowser,
        link: from([
            errorLink,
            headersLink(request),
            authLink(request),
            splitLink,
        ]),
        // Cache management
        cache: new InMemoryCache(cacheConfig).restore(
            isBrowser ? window.APOLLO_STATE : {}
        ),
    });

export default getApolloClient;
